/* global jQuery globalSiteSettings */
(function ($) {
    $.when(window.defTrackingInformation, window.defGeoIP).done(function () { //trackingInfo, geoInfo
        spanishList();
        window.defFormLogic.resolve();
    });

    function spanishList() {
        var spanishPageList = [
            '/es/como-funciona/',
            '/es/prestamos-sobre-el-titulo-del-carro/',
            '/espanol/',
            '/lp/espanol-premier/',
            '/eldinero/',
            '/lp/quinceanera/',
            '/877-el-dinero/',
            '/bienvenido/',
            '/bienvenido-de-nuevo/'
        ];

        if (spanishPageList.indexOf(window.location.pathname) >= 0) {
            // Creating a (dynamic name) class for the element (body) if MT app renders
            // Is needed to add styles only if the MT application is rendered
            var bodyClass = window.location.pathname.replace(/[0-9, /]/g, '');
            // Adding the class to the body element
            $('body').addClass(bodyClass);
        }
        queryDom(spanishPageList.indexOf(window.location.pathname) >= 0);
    }

	// Function used to query the dom for targeted element and swap out href
    function queryDom(val) {
        var _spanishPage = val || false;
        var newLink = '/apply-landing/';
        // eslint-disable-next-line
        var www2Links = document.querySelectorAll("a[href$='www2.800loanmart.com/application/application']");

        if (globalSiteSettings.currentLanguage === 'es' || _spanishPage) {
            newLink = '/es/aplicar-ahora/';
            window.debugLog('Changing www2 to ', newLink);
            // eslint-disable-next-line
            www2Links = document.querySelectorAll("a[href$='www2.800loanmart.com/spanish-landing/application']");
        } else {
            window.debugLog('Changing www2 to ', newLink);
        }

        if (window.LM_CFG.CCB) {
            newLink = '/ccb-lead/';
            window.debugLog('Changing www2 to ', newLink);
        }

        Array.prototype.forEach.call(www2Links, function (www2Link) {
            www2Link.setAttribute('href', newLink);
        });
    }
})(jQuery);
